import {withPermissionHOC} from "../../permission/components/permissionHOC/permissionHOC";
import {access_registrations} from "../../../helpers/rights";
import {useTranslation} from "react-i18next";
import {REGISTRATIONS} from "../locales/namespaces";
import useUserData from "../../../hooks/user/useUserData";
import {API} from "../../../helpers/constants";
import axios from "axios";
import {enqueueSnackbar} from "notistack";
import {handleAxiosErrors} from "../../../helpers/errorHandling";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import {ErrorMessage, FormikProvider} from "formik";
import PageMenu from "../../../components/custom/app/pageMenu/pageMenu";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormHelperText,
    FormLabel, useMediaQuery,
    useTheme
} from "@mui/material";
import {Link, useHistory} from "react-router-dom";
import {NavigateBefore} from "@mui/icons-material";
import PageContentWrapper from "../../../components/mui/app/pageContentWrapper/pageContentWrapper";
import PageTitle from "../../../components/mui/app/pageTitle/pageTitle";
import Grid from "@mui/material/Grid2";
import {formControlDefaults} from "../../../helpers/theme/defaultProps";
import CustomAutocomplete from "../../../components/mui/form/autocomplete/autocomplete";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers-pro";
import Modal from "../../../components/mui/general/modal/modal";
import Delete from "../../../components/app/delete/delete";
import {useCallback, useMemo, useState} from "react";
import useMobileRegistrationForm, {isUUID} from "../hooks/useMobileRegistrationForm";
import RegistrationList from "../components/registrationList";
import {AdapterDayjs} from "@mui/x-date-pickers-pro/AdapterDayjs";
type Props = {};

const MobileForm = (props: Props) => {
    const { registrationId, registration, projects, users, workers, projectWorks } = props
    const { t } = useTranslation(REGISTRATIONS)
    const { dateFormat, token, language } = useUserData();
    const { formik, loadingSubmit, onSubmit } = useMobileRegistrationForm({
        registrationId,
        registration,
        projects,
        users,
        workers,
        projectWorks
    })
    console.log('formik12345',formik.values)
    const [loadingSearch, setLoadingSearch] = useState(false)
    const [projectsData, setProjectsData] = useState(Array.isArray(projects) ? projects : [])
    const [usersData, setUsersData] = useState(Array.isArray(users) ? users : [])
    const [openCopyDialog,setOpenCopyDialog] = useState(false)
    const [date,setDate] = useState('')
    const history = useHistory()
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const handleCopy = (date)=>{
        const parsedDate = dayjs(date, 'DD/MM/YYYY');
        axios({
            method: 'post',
            data:{
                WorkId:registrationId,
                WorkDt:parsedDate.format('YYYY/MM/DD')
            },
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            url: `${API}/en/fts/project/work/copy`
        }).then(res => {
            enqueueSnackbar(t(`Registration copied successfully!`), {
                variant: 'success',
                autoHideDuration: 3000,
            });
            setDate('')
            setOpenCopyDialog(false);
            history.push('/mobile/index')
        }).catch(error => {
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'warning',
                autoHideDuration: 3000,
            })
            setDate('')
            setOpenCopyDialog(false);
        })
    }

    const handleSearch = (evt, name) => {
        let url
        let setter
        let foreman
        switch (name) {
            case 'projectsData':
                url = `${API}/en/fts/project/search`
                setter = setProjectsData
                foreman = 0
                break
            case 'usersData':
                url = `${API}/en/fts/project/user/search`
                setter = setUsersData
                foreman = 1
                break
            default:
                break
        }
        setLoadingSearch(true)
        axios({
            method: 'post',
            data: { 'query': evt.target.value, isForeman: foreman },
            url: url,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
        }).then((response) => {
            if (response.data.result.length > 0) {
                setter(response.data.result)
            }
            setLoadingSearch(false)
        }).catch((error) => {
            enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                variant: 'warning',
                autoHideDuration: 3000,
            })
            setLoadingSearch(false)
        })
    }

    const getRestrictions = useCallback((users, workDate = null) => {
        const checkDate = workDate ? workDate : formik.values.WorkDt
        if (checkDate && checkDate?.isValid() && users && users.length > 0) {
            const formattedDate = dayjs(checkDate).format('YYYY-MM-DD')
            axios({
                method: 'post',
                data: { 'users': users, WorkDt: formattedDate },
                url: `${API}/en/fts/project/work/hours`,
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
            }).then((response) => {
                const data = response.data.totals
                if (data && data.length > 0) {
                    formik.setFieldValue('restrictions', data.map(i => ({
                        workTm: Number(i.WorkTm),
                        extraWorkTm: Number(i.ExtraWorkTm),
                        totalTm: Number(i.Total),
                        userId: i.UserId,
                    })))
                } else {
                    formik.setFieldValue('restrictions', [])
                }
                if (response.data.data){
                    formik.setFieldValue('workProj',response.data.data[0]?.Description)
                }else{
                    formik.setFieldValue('workProj','')
                }
            }).catch((error) => {
                enqueueSnackbar(handleAxiosErrors(error, t('An error occurred!')), {
                    variant: 'warning',
                    autoHideDuration: 3000,
                })
            })
        }
    }, [t, formik])

    const handleDate = (newValue, name) => {
        const users = formik.values.projectWorks.map((i) => (i.UserId?.id))?.filter(f => f)
        getRestrictions(users, newValue)
        formik.setFieldValue(name, newValue);
    };

    // delete button
    const [isDeletionVisible, setIsDeletionVisible] = useState(false)
    const handleDeletionModal = (visible) => {
        setIsDeletionVisible(visible)
    }


    const disableFields = useMemo(() => (Boolean(registrationId) || formik.values.firstRowAdded), [registrationId, formik.values.firstRowAdded])

    return (
        <FormikProvider value={formik}>
            <form
                autoComplete="off"
                id="registrationForm"
                encType="multipart/form-data"
                style={{ marginTop: '10px' }}
            >
                <Box display={'flex'}
                     flexWrap={'wrap'}
                     justifyContent={'space-between'}
                     gap={1}
                sx={{pt:!isMobile && 2}}
                >
                    <PageMenu>
                        <Button
                            component={Link}
                            startIcon={<NavigateBefore/>}
                            to={`/mobile/index`}
                        >
                            {t('Return')}
                        </Button>
                        {registrationId &&
                        <Button
                            size={'small'}
                            variant={'contained'}
                            color={'primary'}
                            onClick={() => setOpenCopyDialog(true)}
                        >
                            {t('Copy')}
                        </Button>
                        }
                        {/*<LoadingButton*/}
                        {/*	loading={loadingSubmit}*/}
                        {/*	onClick={formik.submitForm}*/}
                        {/*	variant="contained"*/}
                        {/*	startIcon={<SaveIcon/>}*/}
                        {/*>*/}
                        {/*	{t('Save')}*/}
                        {/*</LoadingButton>*/}
                    </PageMenu>
                    {registrationId &&
                        <Button
                            size={'small'}
                            variant={'contained'}
                            color={'error'}
                            onClick={() => handleDeletionModal(true)}
                        >
                            {t('Delete')}
                        </Button>
                    }
                </Box>
                <PageContentWrapper>
                    <PageTitle
                        withDivider
                        title={!registrationId ? t('Registration Create') : t('Registration Edit')}
                    />
                    <Grid
                        container
                        spacing={2}
                        sx={{ marginLeft: '0px' }}
                    >
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <FormControl
                                {...formControlDefaults}
                                error={
                                    formik.touched['ProjectId'] &&
                                    Boolean(formik.errors['ProjectId'])
                                }
                            >
                                <FormLabel required>{t('Project')}</FormLabel>
                                <CustomAutocomplete
                                    identifier={'id'}
                                    value={formik.values.ProjectId}
                                    onChange={(evt, newValue) => {
                                        formik.setFieldValue('ProjectId', newValue);
                                    }}
                                    onBlur={() => formik.setFieldTouched('ProjectId', true)}
                                    options={projectsData}
                                    labelKey={'Description'}
                                    onInputChange={(event) => handleSearch(event, 'projectsData')}
                                    otherprops={{
                                        handleHomeEndKeys: true
                                    }}
                                    disabled={disableFields}
                                />
                                <FormHelperText>
                                    <ErrorMessage name={'ProjectId'}/>
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <FormControl
                                {...formControlDefaults}
                                error={
                                    formik.touched['UserId'] &&
                                    Boolean(formik.errors['UserId'])
                                }
                            >
                                <FormLabel required>{t('Foreman')}</FormLabel>
                                <CustomAutocomplete
                                    identifier={'id'}
                                    value={formik.values.UserId}
                                    onBlur={() => formik.setFieldTouched('UserId', true)}
                                    onChange={(evt, newValue) => {
                                        formik.setFieldValue('UserId', newValue);

                                        const { ProjectId, WorkDt} = formik.values;

                                        if (newValue && ProjectId && WorkDt ) {
                                            axios.post(`${API}/en/fts/project/workHeader/update`, {
                                                data: {
                                                   id: registrationId ? registrationId : '',
                                                    UserId: newValue.id,
                                                    ProjectId: ProjectId.id || ProjectId,
                                                    WorkDt: dayjs(WorkDt).format('YYYY-MM-DD')
                                                }
                                            }, {
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'Authorization': `Bearer ${token}`
                                                }
                                            }).then(res => {
                                                console.log('Ενημερώθηκε ο foreman:', res.data);
                                            }).catch(err => {
                                                console.error('Σφάλμα foreman update:', err);
                                            });
                                        }
                                    }}
                                    options={usersData}
                                    labelKey={'Description'}
                                    onInputChange={(event) => handleSearch(event, 'usersData')}
                                    otherprops={{
                                        handleHomeEndKeys: true
                                    }}
                                   // disabled={disableFields}
                                />
                                <FormHelperText>
                                    <ErrorMessage name={'UserId'}/>
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                            <FormControl
                                {...formControlDefaults}
                                error={
                                    formik.touched['WorkDt'] &&
                                    Boolean(formik.errors['WorkDt'])
                                }
                            >
                                <FormLabel required>{t('WorkDt')}</FormLabel>
                                <DatePicker
                                    slotProps={{
                                        textField: {
                                            size: 'small',
                                            variant: 'standard'
                                        }
                                    }}
                                    name="WorkDt"
                                    views={['year', 'month', 'day']}
                                    inputFormat={'DD-MM-YYYY'}
                                    value={formik.values.WorkDt}
                                    onChange={(newValue) => handleDate(newValue, 'WorkDt')}
                                    onBlur={() => formik.setFieldTouched('WorkDt', true)}
                                    format={dateFormat}
                                    disabled={disableFields}
                                />
                                <FormHelperText>
                                    <ErrorMessage name={'WorkDt'}/>
                                </FormHelperText>
                            </FormControl>
                        </Grid>
                    </Grid>
                    <Box>
                           <RegistrationList
                               formik={formik}
                               onSubmit={onSubmit}
                               getRestrictions={getRestrictions}
                               workers = {workers}
                               registrationId={registrationId}
                           />


                            <Modal
                                show={isDeletionVisible}
                                sx={isMobile
                                    ? {
                                        '& .MuiPaper-root': {
                                            position: 'fixed',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            width: '90%',
                                            m: 0,
                                        }
                                    }
                                    : {}
                                }
                            >
                                <Delete
                                    objectId={registrationId}
                                    objectLabel={t('Description')}
                                    objectLabelValue={registration.Description}
                                    deletionUrl={`${API}/en/fts/project/work/remove`}
                                    redirectUrl={`/mobile/index`}
                                    // redirectUrl={`/registrations`}
                                    warningMessage={t('All data related to this registration will be deleted!')}
                                    successMessage={t('Registration deleted successfully!')}
                                    failureMessage={t('Unable to delete registration!')}
                                    handleModal={handleDeletionModal}
                                    onClose={() => setIsDeletionVisible(false)}
                                />
                            </Modal>



                        <Dialog open={openCopyDialog} onClose={() => setOpenCopyDialog(false)}>
                            <DialogTitle>Επιλέξτε ημερομηνία <br/> καταχώρησης</DialogTitle>
                            <DialogContent>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        minHeight: 100, // για να φαίνεται κεντραρισμένο και κάθετα
                                    }}
                                >
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            slotProps={{
                                                textField: {
                                                    variant: 'standard',
                                                },
                                            }}
                                            label="Ημερομηνία"
                                            format="DD/MM/YYYY"
                                            value={date ? dayjs(date, 'DD/MM/YYYY') : null}
                                            onChange={(newValue) => {
                                                if (newValue) {
                                                    setDate(newValue.format('DD/MM/YYYY'));
                                                }
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Box>
                            </DialogContent>

                            <DialogActions sx={{display:'flex', justifyContent:'space-between'}}>
                                <Button variant={'contained'} color={'error'} size={'small'} onClick={() => setOpenCopyDialog(false)}>{t('Cancel')}</Button>
                                <Button
                                    onClick={() => {
                                        handleCopy(date)
                                    }}
                                    variant="contained"
                                >
                                    {t('Copy')}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </Box>
                </PageContentWrapper>
            </form>
        </FormikProvider>
    );
}
export default withPermissionHOC(MobileForm, [access_registrations])